import * as React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { useEffect } from 'react';
import { GetTransactionHistory, GetTransactionStatus } from 'API/DS_Wallet/api';
import { useState } from 'react';
import { Button, Typography } from '@mui/material';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { formattedName } from 'utils/DateFormater';



const columns = [

  {
    id: 'transaction_id',
    label: 'Transaction ID',
    minWidth: 100,
    align: 'left',
  },
  {
    id: 'created_at',
    label: 'Date',
    minWidth: 100,
    align: 'center',
  },
  {
    id: 'amount',
    label: 'Amount',
    minWidth: 170,
    align: 'center',
  },
  { id: 'transaction_type', 
    label: 'Type', 
    minWidth: 60,
     renderCell:(params)=>(
     <Typography>{params.row.transaction_type?formattedName(params.row.transaction_type):'N/A'}</Typography>
  )
   },
  { id: 'wallet_type', 
    label: 'Wallet Type', 
    minWidth: 80 ,
    renderCell:(params)=>(
     <Typography>{params.row.payment_for?formattedName(params.row.payment_for):'N/A'}</Typography>
  )
},
  { id: 'status', label: 'Status', minWidth: 100 },
];

function formatDate(dateString) {
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
}


export default function TransactionTable(props) {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(100);
  const [rows,setRows]=useState(null)
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [AlertType,setAlertType]=useState('success')
  const [AlertMessage,setAlertMessage]=useState(null)

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  useEffect(()=>{
    GetTransactionHistory(setRows,page+1,rowsPerPage)
  },[page])


  const handleCheckStatus=(id)=>{
    GetTransactionStatus(id,setRows,page+1,rowsPerPage,setLoading,handleClick,setAlertMessage,setAlertType,props.handleGetSummary)
  }

  return (
    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
       <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar anchorOrigin={{horizontal:'right',vertical:'top'}} open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity={AlertType}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {AlertMessage}
        </Alert>
      </Snackbar>
      <TableContainer sx={{ maxHeight: 440 }}>
        <Table stickyHeader aria-label="sticky table" size='small'>
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
              <TableCell align='center'>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows&&Array.isArray(rows.transactions)&&rows.transactions
              .map((row) => {
                return (
                  <TableRow  hover role="checkbox" tabIndex={-1} key={row.code}>
                    {columns.map((column) => {
                      const value = row[column.id];
                      let displayValue;
                    
                      if (column.label === 'Date') {
                        displayValue = formatDate(value);
                      } else if (
                        column.id === 'transaction_type' ||
                        column.id === 'wallet_type' ||
                        column.id === 'status'
                      ) {
                        displayValue = formattedName(value.replace("_"," "));
                      } else if (value !== null) {
                        if (typeof value === 'string') {
                          displayValue = value.replace("_", " ");
                        } else {
                          displayValue = value;
                        }
                      } else {
                        displayValue = 'N/A';
                      }
                    
                      return (
                        <TableCell key={column.id} align={column.align}>
                          {displayValue}
                        </TableCell>
                      );
                    })}
                    <TableCell><Button disabled={row.status==='pending'?false:true} onClick={()=>handleCheckStatus(row.transaction_id)}>check status</Button></TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10,100,200]}
        component="div"
        count={rows&&rows.total?rows.total:0}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
}
